import React from 'react'
import '../estilos/footer.css';
import Logo from '../img-etc/logo.png'
import { useTranslation } from 'react-i18next';

function Footer() {
const { t } = useTranslation();

 const enviarWhatsApp = () => {
  const telefonoEmpresa = "50664643174";
  const mensaje = "Hola 👋 quiero más información sobre sus tours 🌿";
  const url = `https://wa.me/${telefonoEmpresa}?text=${encodeURIComponent(mensaje)}`;
  window.open(url, "_blank");
};
  return (
    <section className="footer">
  <div className="footer-container">
    {/* ===== BRAND ===== */}
    <div className="footer-col footer-brand">
      <div className="footer-logo">
        <img className='Imglogo' src={Logo} alt="Pacific Tour CR Logo" />
      </div>

      <h2>Pacific Tour CR</h2>
      
      <div className="footer-locations">
        <div className="location-item">
          <span className="location-icon">📍</span>
          <div>
            <p className="location-name">Liberia, Costa Rica</p>
            <p className="location-detail"></p>
          </div>
        </div>
        <div className="location-item">
          <span className="location-icon">📍</span>
          <div>
            <p className="location-name">Vero Beach, Florida</p>
            <p className="location-detail">United States - 32960</p>
          </div>
        </div>
      </div>

      <div className="footer-contacts">
        <a href="mailto:info@pacifictourcr.com" className="footer-contact">
          <span className="contact-icon">✉️</span>
          <span>info@pacifictourcr.com</span>
        </a>
      </div>
    </div>

    {/* ===== HOURS ===== */}
    <div className="footer-col">
      <h3>{t('footer_horario')}</h3>

      <ul className="footer-hours">
        <li>
          <span className="day">{t('footer_lunes_viernes')}</span>
          <span className="time">5:00 AM - 10:00 PM</span>
        </li>
        <li>
          <span className="day">{t('footer_sabado')}</span>
          <span className="time">5:00 AM - 10:00 PM</span>
        </li>
        <li>
          <span className="day">{t('footer_domingo')}</span>
          <span className="time">5:00 AM - 10:00 PM</span>
        </li>
      </ul>

      <div className="availability-badge">
        <span className="status-dot"></span>
        <span>{t('footer_disponible')}</span>
      </div>
    </div>

    {/* ===== SOCIAL ===== */}
    <div className="footer-col">
      <h3>{t('footer_siguenos')}</h3>

      <div className="footer-socials">
        <a href="https://www.facebook.com/pacific.tours.cr.2025?rdid=0ZPgNRtHk9rPLWkQ&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15VvS4k4P5%2F#" className="social-circle" aria-label="Facebook">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
        </a>
        <a href="https://www.instagram.com/pacific_tours_cr" className="social-circle" aria-label="Instagram">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
          </svg>
        </a>
        
        <a onClick={enviarWhatsApp} className="social-circle" aria-label="WhatsApp" style={{cursor: 'pointer'}}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
          </svg>
        </a>
      </div>

      {/* <button className="footer-btn">
        <span>Nuestras Sucursales</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button> */}
    </div>

    {/* ===== TAGS ===== */}
    <div className="footer-col">
      <h3>{t('footer_experiencias')}</h3>

      <div className="footer-tags">
        <span>#Arenal</span>
        <span>#Transportation</span>
        <span>#Transfer</span>
        <span>#CostaRica</span>
        <span>#Guanacaste</span>
        <span>#Tours</span>
        <span>#PartyBoat</span>
        <span>#SportFishing</span>
        <span>#Excursion</span>
        <span>#ZipLine</span>
      </div>
    </div>

  </div>


  <div className="footer-bottom">
    <div className="footer-bottom-content">
      <p>{t('footer_derechos')}</p>
      <div className="footer-bottom-links">
        <a href="#">{t('footer_terminos')}</a>
        <span>·</span>
        <a href="#">{t('footer_privacidad')}</a>
      </div>
    </div>
  </div>
</section>
  )
}

export default Footer